module.exports = __webpack_public_path__ + "static/img/ctjieduimg5.fb35051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctjieduimg5.png
// module id = 1ysd
// module chunks = 5